import { DetailedHTMLProps, FormHTMLAttributes } from 'react'
import clsx from 'clsx'

export const AuthForm = ({
  className,
  ...props
}: DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>) => (
  <form className={clsx('flex w-full max-w-md flex-col gap-4', className)} {...props} />
)
